import React from 'react';
import { useEffect, useState, useRef } from 'react';
import './stepone.component.css';
import { getStockPriceOnDate, searchCompany } from '../../../../api';
import { X } from 'react-bootstrap-icons';
import moment from 'moment';
import DatePickerCustomized from './date_picker_customized/date_picker_customized.component';
import SearchBar from './search_bar/search_bar.component';
import { mergeRefs } from './utils';
import { Row, Cell } from 'react-sticky-table';
import Dropdown from '../../../common/dropdown/dropdown.component';

const TxTable = React.forwardRef((props, ref) => {
  // Inputs dropdown position
  const searchBarRef = useRef(null);
  const typeSelectRef = useRef(null);
  const [searchDropdownPos, setSearchDropdownPos] = useState({});
  const [typeDropdownPos, setTypeDropdownPos] = useState({});

  const [currentEditedTxIdx, setCurrentEditedTxIdx] = useState(0);
  const [currentEditable, setCurrentEditable] = useState('');
  const currentEditableElem = useRef(null);
  const lastTxSharesInputRef = ref ? ref.lastTxSharesInputRef : null;
  const lastAddedTxRef = ref ? ref.lastAddedTxRef : null;

  // Search functionality
  const onSearchClick = async (c) => {
    let txs = [...props.txs];
    let currentEditedTx = txs[currentEditedTxIdx];
    if (moment(c.data_inception_date).isValid()) {
      const inceptionDateObj = new Date(c.data_inception_date);
      if (currentEditedTx.date_obj < inceptionDateObj) {
        currentEditedTx = {
          ...currentEditedTx,
          date_obj: inceptionDateObj,
          date: moment(inceptionDateObj).format('DD-MM-YYYY'),
        };
      }
    }
    let price = await get_and_set_price(
      c.fincode,
      moment(currentEditedTx.date_obj).format('DDMMYYYY'),
    );
    txs[currentEditedTxIdx] = {
      ...currentEditedTx,
      company_id: c.id,
      company_name: c.short_name,
      price: price,
      cost_value: (price * currentEditedTx.shares).toFixed(2),
      data_inception_date: c.data_inception_date,
      fincode: c.fincode,
    };
    props.setTxs(txs);
    setCurrentEditable('');
  };

  const onSearchBlur = () => {
    setCurrentEditable('');
  };

  const getSetDropdownsPosition = (currentEditable) => {
    const modalBody =
      props.containerRef.current.parentElement.getBoundingClientRect();
    if (currentEditable === 'company_name') {
      let searchDropdownPos = {};
      // search input
      const searchBarPos = searchBarRef.current.getBoundingClientRect();
      const searchBarWidth = searchBarPos.width;
      searchDropdownPos['width'] = searchBarWidth;
      searchDropdownPos['left'] = searchBarPos.left;
      const spaceAvail = modalBody.bottom - searchBarPos.bottom;
      spaceAvail > 160
        ? (searchDropdownPos['top'] = searchBarPos.bottom)
        : (searchDropdownPos['bottom'] = window.innerHeight - searchBarPos.top);
      setSearchDropdownPos(searchDropdownPos);
      return;
    }
    if (currentEditable === 'type') {
      let typeDropdownPos = {};
      // tx type input
      const typeInputPos = typeSelectRef.current.getBoundingClientRect();
      const typeInputWidth = typeInputPos.width;
      typeDropdownPos['width'] = typeInputWidth;
      typeDropdownPos['left'] = typeInputPos.left;
      const spaceAvail = modalBody.bottom - typeInputPos.bottom;
      spaceAvail > 100
        ? (typeDropdownPos['top'] = typeInputPos.bottom)
        : (typeDropdownPos['bottom'] =
            window.innerHeight - typeInputPos.top - 16);
      setTypeDropdownPos(typeDropdownPos);
      return;
    }
  };

  const onSelectType = (type) => {
    let txs = [...props.txs];
    txs[currentEditedTxIdx] = {
      ...txs[currentEditedTxIdx],
      type: type,
    };
    props.setTxs(txs);
  };

  const get_and_set_price = async (fincode, on_date) => {
    if (!fincode || !on_date) return;
    const res = await getStockPriceOnDate(fincode, on_date);
    const stock_price = res.data.data.value;
    return stock_price;
  };

  const handleEdit = (col, i, e) => {
    e.stopPropagation();
    setCurrentEditedTxIdx(i);
    setCurrentEditable(col);
    if (col === 'date') {
      currentEditableElem.current = e.currentTarget;
    }
  };

  useEffect(() => {
    if (currentEditable != '' && currentEditableElem.current) {
      let editableElem = currentEditableElem.current;
      if (currentEditable === 'date') {
        editableElem.querySelector('.add-tx-date-input').click();
        return;
      }
      if (currentEditable === 'company_name' || currentEditable === 'type') {
        setTimeout(() => getSetDropdownsPosition(currentEditable));
      }
      editableElem.focus();
    }
  }, [currentEditable]);

  const onSharesChange = (shares) => {
    let txs = [...props.txs];
    let currentEditedTx = txs[currentEditedTxIdx];
    txs[currentEditedTxIdx] = {
      ...currentEditedTx,
      shares: shares,
      cost_value: (currentEditedTx.price * (shares || 0)).toFixed(2),
    };
    props.setTxs(txs);
  };

  const onDateChange = async (date_obj, idx) => {
    const date = moment(date_obj).format('DD-MM-YYYY');
    let txs = [...props.txs];
    let currentEditedTx = txs[currentEditedTxIdx];
    let price = await get_and_set_price(
      props.txsFincode[idx],
      moment(date_obj).format('DDMMYYYY'),
    );
    txs[currentEditedTxIdx] = {
      ...currentEditedTx,
      date_obj,
      date,
      price,
      cost_value: (price * currentEditedTx.shares).toFixed(2),
    };
    props.setTxs(txs);
  };

  const onDateRawChange = (e, i, min_date) => {
    let dateStr = e.target.value;
    if (props.isError) {
      props.setIsError(false);
    }
    if (moment(dateStr, 'D-M-YYYY', true).isValid()) {
      dateStr = dateStr.split('-').reverse().join('-');
      let date_obj = new Date(dateStr);
      const minDate = new Date(min_date);
      if (date_obj > new Date()) {
        props.setErrorText('Date cannot be in the future');
        props.setIsError(true);
        return;
      }
      if (minDate && date_obj < minDate) {
        props.setErrorText(
          `Date should be later than ${moment(minDate).format('DD-MM-YYYY')}`,
        );
        props.setIsError(true);
        return;
      }
      onDateChange(date_obj, i);
    }
  };

  const onSharePriceChange = (price) => {
    if (price <= 0) return;
    let txs = [...props.txs];
    let currentEditedTx = txs[currentEditedTxIdx];
    txs[currentEditedTxIdx] = {
      ...currentEditedTx,
      price,
      cost_value: ((price || 0) * (currentEditedTx.shares || 0)).toFixed(2),
    };
    props.setTxs(txs);
  };

  const getRowClass = (company_name) => {
    let className = 'table-row';
    if (
      props.invalidComps.length &&
      props.invalidComps.includes(company_name)
    ) {
      className += ' invalid-tx';
    }
    return className;
  };

  return (
    <>
      {props.txs &&
        props.txs.map((t, i) => (
          <Row
            className={getRowClass(t.company_name)}
            key={i}
            ref={i === props.txs.length - 1 ? lastAddedTxRef : null}
          >
            <Cell
              className="pl-3 py-2"
              onClick={(e) => handleEdit('company_name', i, e)}
            >
              {currentEditable === 'company_name' &&
              currentEditedTxIdx === i ? (
                <SearchBar
                  placeholder={t.company_name}
                  onSearchClick={onSearchClick}
                  suggestionsPosition={searchDropdownPos}
                  containerRef={props.containerRef}
                  containerClass="input-br"
                  onBlur={onSearchBlur}
                  ref={mergeRefs([currentEditableElem, searchBarRef])}
                />
              ) : (
                <span className="tx-table-editable">{t.company_name}</span>
              )}
            </Cell>
            <Cell
              className="pl-3 py-2 text-capitalize"
              onClick={(e) => handleEdit('type', i, e)}
            >
              {currentEditable === 'type' && currentEditedTxIdx === i ? (
                <Dropdown
                  selected={t.type.toLowerCase()}
                  setSelected={onSelectType}
                  placeholder="Buy/Sell"
                  options={['BUY', 'SELL']}
                  containerClass="input-br select"
                  ref={mergeRefs([currentEditableElem, typeSelectRef])}
                  optionsPosition={typeDropdownPos}
                  onBlur={() => setCurrentEditable('')}
                />
              ) : (
                <span className="tx-table-editable">
                  {t.type.toLowerCase()}
                </span>
              )}
            </Cell>
            <Cell
              className="text-right pr-5 py-2"
              onClick={(e) => handleEdit('shares', i, e)}
              ref={lastTxSharesInputRef}
            >
              {currentEditable === 'shares' && currentEditedTxIdx === i ? (
                <input
                  className="text-right input-br bare"
                  type="number"
                  min={0}
                  value={t.shares}
                  placeholder="Shares"
                  onChange={(e) => {
                    onSharesChange(parseInt(e.target.value));
                  }}
                  onBlur={() => setCurrentEditable('')}
                  ref={currentEditableElem}
                ></input>
              ) : (
                <span className="tx-table-editable">{t.shares}</span>
              )}
            </Cell>
            <Cell
              className="pl-3 py-2"
              onClick={(e) => handleEdit('date', i, e)}
            >
              {currentEditable === 'date' && currentEditedTxIdx === i ? (
                <DatePickerCustomized
                  selected={t.date_obj}
                  onSelect={(d) => {
                    onDateChange(d, i);
                  }}
                  onChangeRaw={(e) =>
                    onDateRawChange(e, i, t.data_inception_date)
                  }
                  onBlur={() => {
                    props.setIsError(false);
                    setCurrentEditable('');
                  }}
                  minDate={
                    moment(t.data_inception_date).isValid()
                      ? t.data_inception_date
                      : ''
                  }
                  inputClass="input-br bare"
                />
              ) : (
                <span className="tx-table-editable">
                  {moment(t.date_obj).format('DD-MM-YYYY')}
                </span>
              )}
            </Cell>
            <Cell
              className="text-right pr-3 py-2"
              onClick={(e) => handleEdit('price', i, e)}
            >
              {currentEditable === 'price' && currentEditedTxIdx === i ? (
                <input
                  className="text-right input-br bare"
                  min={0}
                  type="number"
                  step="0.01"
                  placeholder="Share price"
                  value={t.price}
                  onChange={(e) => {
                    onSharePriceChange(parseFloat(e.target.value));
                  }}
                  onBlur={() => setCurrentEditable('')}
                ></input>
              ) : (
                <span className="tx-table-editable">{t.price}</span>
              )}
            </Cell>
            <Cell className="text-right pr-3 py-2">{t.cost_value}</Cell>
            <Cell className="text-center px-3 py-2">
              <span className="text-danger pointer">
                <X onClick={(e) => props.removeTx(i)} />
              </span>
            </Cell>
          </Row>
        ))}
    </>
  );
});

export default TxTable;
